var _a;
import { SearchDocumentType, CompressedSearchDocumentType, } from '@wix/client-search-sdk';
var minifiedTitles = (_a = {},
    _a[SearchDocumentType.All] = CompressedSearchDocumentType.All,
    _a[SearchDocumentType.Products] = CompressedSearchDocumentType.Products,
    _a[SearchDocumentType.Bookings] = CompressedSearchDocumentType.Bookings,
    _a[SearchDocumentType.Events] = CompressedSearchDocumentType.Events,
    _a[SearchDocumentType.Blogs] = CompressedSearchDocumentType.Blogs,
    _a[SearchDocumentType.Pages] = CompressedSearchDocumentType.Pages,
    _a[SearchDocumentType.Forums] = CompressedSearchDocumentType.Forums,
    _a);
var convertBooleanToNumber = function (bool) {
    return bool ? 1 : 0;
};
export var compress = function (input) {
    var result = [];
    for (var categoryTitle in input) {
        var _a = input[categoryTitle], index = _a.index, visible = _a.visible, useOverride = _a.useOverride, override = _a.override;
        result.push([
            minifiedTitles[categoryTitle],
            index,
            convertBooleanToNumber(visible),
            convertBooleanToNumber(useOverride),
            override,
        ]);
    }
    return { s: result };
};
export var uncompress = function (input) {
    var result = {};
    var _loop_1 = function (item) {
        var category = Object.entries(minifiedTitles).find(function (_a) {
            var _ = _a[0], value = _a[1];
            return value === item[0];
        });
        if (!category) {
            return "continue";
        }
        var categoryTitle = category[0];
        var index = item[1];
        var visible = Boolean(item[2]);
        var useOverride = Boolean(item[3]);
        var override = item[4];
        result[categoryTitle] = { index: index, visible: visible, useOverride: useOverride, override: override };
    };
    for (var _i = 0, _a = input.s; _i < _a.length; _i++) {
        var item = _a[_i];
        _loop_1(item);
    }
    return result;
};
export var searchAppSettings = {
    categoryList: {
        key: 'categoryList',
        getDefaultValue: function () {
            return {
                s: [
                    [CompressedSearchDocumentType.All, 100, 1, 0, ''],
                    [CompressedSearchDocumentType.Products, 110, 1, 0, ''],
                    [CompressedSearchDocumentType.Bookings, 120, 1, 0, ''],
                    [CompressedSearchDocumentType.Events, 130, 1, 0, ''],
                    [CompressedSearchDocumentType.Blogs, 140, 1, 0, ''],
                    [CompressedSearchDocumentType.Pages, 150, 1, 0, ''],
                    [CompressedSearchDocumentType.Forums, 160, 1, 0, ''],
                ],
            };
        },
    },
};
//# sourceMappingURL=searchAppSettings.js.map